"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _noop = _interopRequireDefault(require("lodash/noop"));
var _useInvalidateRefdata = _interopRequireDefault(require("./useInvalidateRefdata"));
var _useMutateGeneric = _interopRequireDefault(require("./useMutateGeneric"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useMutateRefdataValue = _ref => {
  let {
    afterQueryCalls: {
      delete: afterQueryDelete = _noop.default,
      post: afterQueryPost = _noop.default,
      put: afterQueryPut = _noop.default
    } = {},
    endpoint,
    id,
    ...mutateGenericProps
  } = _ref;
  const invalidateRefdata = (0, _useInvalidateRefdata.default)();
  return (0, _useMutateGeneric.default)({
    afterQueryCalls: {
      delete: res => {
        invalidateRefdata().then(() => {
          afterQueryDelete(res);
        });
      },
      post: res => {
        invalidateRefdata().then(() => {
          afterQueryPost(res);
        });
      },
      put: res => {
        invalidateRefdata().then(() => {
          afterQueryPut(res);
        });
      }
    },
    endpoint,
    id,
    promiseReturns: {
      delete: (delId, ky) => ky.put(`${endpoint}/${id}`, {
        json: {
          id,
          values: [{
            id: delId,
            _delete: true
          }]
        }
      }).json(),
      post: (data, ky) => ky.put(`${endpoint}/${id}`, {
        json: {
          id,
          values: [data]
        }
      }).json(),
      put: (data, ky) => ky.put(`${endpoint}/${id}`, {
        json: {
          id,
          values: [data]
        }
      }).json()
    },
    queryKey: ['stripes-kint-components', 'useMutateRefdataValue', id],
    ...mutateGenericProps
  });
};
var _default = exports.default = useMutateRefdataValue;